<template>
  <div>
    <!-- Nav tabs -->
    <ul class="nav nav-tabs" role="tablist" :id="crowdOrRais + 'tabs'">
      <li><a class="first">{{ $t("project.show.campaignDetails") }}</a></li>
      <li role="presentation" class="active"><a href="#campaign-story" aria-controls="campaign-story" role="tab" data-toggle="tab">{{ $t("project.story") }}</a></li>
      <li role="presentation"><a href="#campaign-author" aria-controls="campaign-author" role="tab" data-toggle="tab">{{ $t("author") }}</a></li>
      <li role="presentation"><a href="#campaign-backers" aria-controls="campaign-backers" role="tab" data-toggle="tab">{{ $t("project.backers") }} {{ contributions.length }}</a></li>
      <li role="presentation"><a href="#campaign-comments" aria-controls="campaign-comments" role="tab" data-toggle="tab">{{ $t("comments") }} {{ comments.length }}</a></li>
    </ul>
    <!-- Tab panes -->
    <div class="tab-content">
      <!-- Story -->
      <div role="tabpanel" class="tab-pane fade in active" id="campaign-story">
        <div class="row">
          <div class="col-md-8">
            <h3 style="margin-top:0px">{{ $t('project.storySlogan') }}</h3>
          </div>
          <div class="col-md-4">
            <p>{{ $t('project.show.selectDescriptionLanguage') }}</p>
            <div class="row select-language-buttons" v-if="project.translations">
              <div v-for="language in project.translations" class="col-lg-4 col-xs-6">
                <button
                  :value="language.locale"
                  type="button"
                  class="select-language-btn sm text-center"
                  :class="[{ crowd: project.crowdfunding, raise: !project.crowdfunding, active: language.locale === locale}]"
                  @click="changeLanguage(language.locale)">
                  {{ $t(`language.${language.locale}`) }}
                </button>
              </div>
            </div>
          </div>
          <div v-if="project.video_url" class="col-md-12">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe ref="videoRef" :src="project.video_url.replace('watch?v=', 'embed/')" id="video-container" controls></iframe>
            </div>
          </div>
          <div class="col-md-12 mt-30">
            <p style="word-wrap: break-word;" v-html="project.story"></p>
          </div><!-- Story -->
        </div>
      </div>
      <!-- Author -->
      <div role="tabpanel" class="tab-pane fade" id="campaign-author">
        <div class="avatar">
          <img v-if="project.user.photo.thumb.url" :src="$server_url + project.user.photo.thumb.url">
        </div>
        <h3 style="display:inline;vertical-align:middle">{{ project.user.full_name }} <span v-if="project.user.profession">({{ project.user.profession.name }})</span></h3>
        <h4 class="-text-center">{{ $t('profile.informationAboutUser') }}</h4>
        <p style="word-wrap: break-word;" class="author-about" v-html="project.user.description"></p>
        <h4>
          <router-link v-if="project.user.id" :to="{ name: 'show_profile', params: { id: project.user.id }}">
            {{ $t('profile.viewFullProfile') }}
          </router-link>
        </h4>
        <h3 v-if="team.length" class="mt-50">{{ $t('project.show.OtherTeamMembers') }}</h3>
        <div v-for="(member, index) in team" :key="index" class="team-members" style="display:flex;justify-content:space-between;align-items:center;">
          <div>
            <div class="avatar">
              <img v-if="member.user.photo.thumb.url" :src="$server_url + member.user.photo.thumb.url">
            </div>
            <h3 style="display:inline;vertical-align:middle">{{ member.user.full_name }}</h3>
          </div>
          <h4>
            <router-link v-if="member.user.id" :to="{ name: 'show_profile', params: { id: member.user.id }}">
              {{ $t('profile.viewFullProfile') }}
            </router-link>
          </h4>
        </div>
      </div><!-- Author -->
      <!-- Backers -->
      <div role="tabpanel" class="tab-pane fade" id="campaign-backers">
        <div v-for="contribution in contributions" class="backer">
          <p v-if="contribution.anonymous">{{ $t('anonymous') }}</p>
          <div v-else>
            <div v-if="contribution.user.photo.thumb.url" class="avatar small">
              <router-link :to="{ name: 'show_profile', params: { id: contribution.user.id }}">
                <img v-if="project.user.photo.thumb.url" :src="$server_url + contribution.user.photo.thumb.url">
                <img v-else src="~assets/img/specialist.jpg">
              </router-link>
            </div>
            <router-link :to="{ name: 'show_profile', params: { id: contribution.user.id }}">
              <strong>{{ contribution.user.full_name }}</strong>
            </router-link>
          </div>
          <span class="when">{{ contribution.created_at | daysLeft }} {{ $t('daysAgo') }}</span>
          <span class="pull-right">
            <strong>{{ project.currency | currencySymbol }}{{ contribution.amount }}</strong>
          </span>
        </div>
      </div><!-- Backers -->
      <!-- Comments -->
      <div role="tabpanel" class="tab-pane fade" id="campaign-comments">
        <transition-group name="list" tag="p" class="scroll-list">
          <p v-for="comment in comments" :key="comment.id" class="comment">
            <router-link :to="{ name: 'show_profile', params: { id: comment.user.id } }">
              <div v-if="comment.user.photo.thumb.url" class="avatar" style="height:60px">
                <img :src="$server_url + comment.user.photo.thumb.url" style="width:60px">
              </div>
              <strong>{{ comment.user.full_name }}</strong>
            </router-link>
            <span class="when">{{ comment.created_at | daysLeft }} {{ $t('daysAgo') }}</span>
            </br>
            {{ comment.body }}
          </p>
        </transition-group>
        <form v-if="user.email">
          <textarea v-model="comment.body" class="form-control" rows="5" id="leave-comment" :placeholder="$t('project.show.leaveComment')"></textarea>
          <button type="button" @click="addComment" :disabled="!comment.body" :class="'btn btn-default btn-lg crowdfunding button-center-' + crowdOrRais">{{ $t("send") }}</button>
        </form>
        <div v-else>
          <h2>{{ $t('project.show.logInToAddComment') }}</h2>
        </div>
      </div><!-- Comments -->
    </div><!-- .tab-content -->
  </div>
</template>

<script>
import projectsApi from '@/api/v1/projects';
import commentsApi from '@/api/v1/comments';
import teamApi from '@/api/v1/team';
import auth from '@/api/v1/auth/authService';

export default {
  props: ['project'],
  data() {
    return {
      contributions: [],
      team: [],
      comments: [],
      comment: { body: '' },
      user: auth.user,
      locale: localStorage.getItem('lang'),
    };
  },
  computed: {
    crowdOrRais() {
      return this.project.crowdfunding ? 'crowd' : 'rais';
    },
  },
  methods: {
    addComment() {
      commentsApi.new(this.$route.params.id, this.comment.body).then((response) => {
        this.comments.unshift(response.data);
        this.comment.body = '';
      });
    },
    changeLanguage(locale) {
      const vm = this;
      vm.project.translations.forEach((translation) => {
        if (translation.locale === locale) {
          vm.project.story = translation.story;
          vm.project.description = translation.description;
        }
      });
      vm.locale = locale;
    },
  },
  created() {
    projectsApi.contributions(this.$route.params.id, (contributions) => { this.contributions = contributions; });
    commentsApi.projectComments(this.$route.params.id, (comments) => { this.comments = comments; });
    teamApi.getProjectCollaborators(this.$route.params.id, (response) => { this.team = response; });
  },
};
</script>



// WEBPACK FOOTER //
// Details.vue?7d713344